import { FC, memo } from 'react';

import LocatieLabel from '@/apps/mwd-v2/components/Domain/LocatieLabel/LocatieLabel';
import useClientState from '@/state/useClientState';
import { Group } from '@visx/group';

import { MwdEenheidWerklijn, MwdWerklijn } from '../../types/Domain';

import Deeltraject from './Deeltraject/Deeltraject';
import Overgang from './Overgang/Overgang';
import WerklijnStatusOvergang from './WerklijnStatusOvergang';

type WerklijnProps = {
  werklijn: MwdEenheidWerklijn | MwdWerklijn;
  werklijnY?: number;
  miniMwd?: boolean;
  isAllowedToMutate: boolean;
};

const Werklijn: FC<WerklijnProps> = ({ werklijn, isAllowedToMutate, werklijnY, miniMwd = false }) => {
  const mwdWidth = useClientState((state) => (miniMwd ? state.miniMwd.width : state.mwd.width));
  const y = werklijnY ?? werklijn.y;

  return (
    <Group data-eenheid={werklijn.eenheid.nummer} top={y} left={0} height={werklijn.height} width={mwdWidth}>
      <rect width={mwdWidth} fill='var(--mwd-werklijn-color-background)' height={22} />
      {werklijn.statusVanWerklijn.map((statusVanWerklijn) => (
        <WerklijnStatusOvergang
          key={`status-overgangen_${statusVanWerklijn.status}_${statusVanWerklijn.begindatumtijd.toISOString()}_${statusVanWerklijn.einddatumtijd.toISOString()}`}
          statusOvergang={statusVanWerklijn}
        />
      ))}
      <Overgang
        key={`eerste-overgangen_${werklijn.eersteOvergang.werklijnId}_${werklijn.eersteOvergang?.aankomstTijdVoorgaandeInzet?.toISOString() ?? werklijn.eersteOvergang?.vertrekTijdVolgendeInzet?.toISOString()}`}
        overgang={werklijn.eersteOvergang}
        isAllowedToMutate={isAllowedToMutate}
        miniMwd={miniMwd}
      />

      {werklijn.overgangen.map((overgang) => (
        <Overgang
          key={`overgangen_${overgang.werklijnId}_${overgang?.aankomstTijdVoorgaandeInzet?.toISOString() ?? overgang?.vertrekTijdVolgendeInzet?.toISOString()}`}
          overgang={overgang}
          miniMwd={miniMwd}
          isAllowedToMutate={isAllowedToMutate}
        />
      ))}

      {werklijn.deelTrajecten.map((deeltraject) => (
        <Deeltraject
          miniMwd={miniMwd}
          key={`deeltrajecten_${deeltraject.wleId}_${deeltraject.vertrekTijd.toISOString()}`}
          deeltraject={deeltraject}
          isAllowedToMutate={isAllowedToMutate}
        />
      ))}
      {werklijn.locatieLabels.map((locatieLabel) => (
        <LocatieLabel
          key={`locatieLabel-${locatieLabel.dienstregelpunt}-${locatieLabel.x}`}
          positionLeft={locatieLabel.x}
          dienstregelpunt={locatieLabel.dienstregelpunt}
        />
      ))}
    </Group>
  );
};
export default memo(Werklijn);
